const messages = {
  back: 'regresar',
  welcome: '{Name}, la sonrisa de tus sueños esta cerca',
  select: 'Selecciona día y horario',
  noDate: 'No tenemos horarios en este día, selecciona otro'
}

export default messages
